// extracted by mini-css-extract-plugin
export default {"module":"landing_module__ilcEp","header":"landing_header__cqg3x","content":"landing_content__nosTY"};